
import Vue from 'vue';
import ElementUI from 'element-ui';
import Cookies from 'js-cookie';

/***********************************************用户配置********************************************************/

//基本设置与登录注册找回密码窗口
Vue.prototype.$appName = "林场问题反馈系统"; //标题
Vue.prototype.$color = ""; //默认主题颜色（所有按钮颜色）
Vue.prototype.$login = require("../assets/back1.jpg");//背景图
Vue.prototype.$logo = require("../assets/1.png");//LOGO图
// Vue.prototype.$home = require("../assets/logo.png");//主页背景图

//普通用户界面
//Vue.prototype.$homeStyle = "height:920px;width:2120px";//登录注册找回密码窗口主LOGO上边距
//管理员用户界面
Vue.prototype.$homeStyle = "height:900px;width:1950px";//登录注册找回密码窗口主LOGO上边距

Vue.prototype.$logoWidth = 50;//登录注册找回密码窗口LOGO宽度
Vue.prototype.$logoHeight = 50;//登录注册找回密码窗口LOGO高度
Vue.prototype.$logoStyle = "margin-top:25px";//登录注册找回密码窗口主LOGO上边距
Vue.prototype.$logeTitleWidth = 17;//登录窗口文字宽度占比

//标题栏设置
Vue.prototype.$headerLogoHeight = 40;//登录注册找回密码窗口LOGO高度
Vue.prototype.$headerLogoWidth = 40;//登录注册找回密码窗口LOGO宽度
Vue.prototype.$headerStyle = "background-color:#008888;;width:100%;height:60px;border-bottom:#008888 solid 0px;letter-spacing:3px";
Vue.prototype.$headerLogoStyle = "position:absolute;left:20px;top:13px";//登录注册找回密码窗口主LOGO上边距
Vue.prototype.$headerTitleStyle = "color:#fff;position: absolute;left:75px;letter-spacing:2px color:";//Header开启分割条
Vue.prototype.$headerIconStyle = "color:#fff;font-size:15px;position:absolute;right:210px;top:23px;";//Header开启分割条
Vue.prototype.$headerSetStyle = "position:absolute;right:120px;top:19px;";//Header个信按钮
Vue.prototype.$headerExitStyle = "position:absolute;right:30px;top:19px;";//Header退出按钮

//菜单栏样式
Vue.prototype.$sideColor = "#555555";//Side颜色
Vue.prototype.$sideTextColor = "#fff";//Side文字颜色
Vue.prototype.$sideTextActiveColor = "#ff0";//Side文字选中颜色

/******************************************ElementUI配置***************************************************/

ElementUI.TableColumn.props.showOverflowTooltip = { type: Boolean, default: true }
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.top.default = "10vh"
ElementUI.Dialog.props.appendToBody.default = true
ElementUI.Dialog.props.title.default = "请填写信息"
ElementUI.Table.props.stripe = { type: Boolean, default: true }
ElementUI.Table.props.border = { type: Boolean, default: true }
ElementUI.Upload.props.showFileList.default = false
ElementUI.Form.props.labelPosition.default = "top"
Vue.use(ElementUI, { size: Cookies.get('size') || 'medium', });
